module.exports = ".background{\r\n\tbackground-color: #081856;\r\n}\r\n\r\n.col-lg-2-18 h4, .col-lg-2-18 p {\r\n\tfont-family: \"Gotham-Book\";\r\n}\r\n"